export default "__VITE_ASSET__kpujGTxm__"